import React from "react";
import { Outlet } from "react-router-dom";
import { makeStyles, tokens } from "@fluentui/react-components";
import { Header, SideNav, BottomTabBar } from "../components";
import { useIsMobile, useIsLandscape } from "../hooks";

const useStyles = makeStyles({
  page: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    backgroundColor: tokens.colorNeutralBackground2,
  },
  body: {
    display: "flex",
    flexGrow: 1,
    minHeight: 0,
    overflow: "hidden",
  },
  main: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    minWidth: 0,
    paddingLeft: tokens.spacingHorizontalL,
    paddingRight: tokens.spacingHorizontalL,
    paddingTop: tokens.spacingVerticalXXL,
    paddingBottom: tokens.spacingVerticalXXL,
    overflowY: "auto",
  },
});

export const AppLayout: React.FC = () => {
  const styles = useStyles();
  const isMobile = useIsMobile();
  const isLandscape = useIsLandscape();

  return (
    <div className={styles.page}>
      <Header />
      <div className={styles.body}>
        {(!isMobile || isLandscape) && <SideNav />}
        <main className={styles.main}>
          <Outlet />
        </main>
      </div>
      {isMobile && !isLandscape && <BottomTabBar />}
    </div>
  );
};
